module.exports = __webpack_public_path__ + "img/confirm-button.26fa8f44.png";